<template>
    <div class="row">
        <div class="col-12">
            <div class="card-header-actions">
              <div class="col-12 justify-content-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_CAD_BUILDING_FIELD_REGRESSION_ADD')" @click="showBuildingFieldAddModal(null)">{{$t("action.add")}}</button>
              </div>
            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>Код</th>
                      <th>Текст</th>
                      <th>Текст(ru)</th>
                      <th>Мажбурий</th>
                      <th>Тури</th>
                      <th>Категория</th>
                      <th>Референс</th>
                      <th class="text-center">{{$t("realEstate.field.action")}}</th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                      <tr v-for="result in results.data" :key="result.id">
                          <td>{{result.code}}</td>
                          <td>{{result.name}}</td>
                          <td>{{result.nameRu}}</td>
                          <td>{{result.required ? 'Ҳа' : 'Йўқ'}}</td>
                          <td>{{ result.type}}</td>
                          <td>
                              <span v-if="result.buildingCategory==='Notorious'">Нотурар</span>
                              <span v-if="result.buildingCategory==='Residential'">Турар</span>
                          </td>
                          <td>{{result.reference ? result.reference.name : ''}}</td>
                          <td class="td-actions text-center">
                              <button class="all-btn edit-btn table-action" data-original-title="Edit"
                                      @click="showBuildingFieldAddModal(result)">
                                  <i class="fa fa-edit"></i>
                              </button>
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5"
                      v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <BuildingFieldEditModal/>
    </div>
</template>

<script>
    import BuildingFieldEditModal from './BuildingFieldEditModal'
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';

    export default {
        components: {
            'b-pagination': bPagination,
            BuildingFieldEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('/building/field/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false
                    }, err => {
                        console.log(err);
                        this.loading = false
                    })
            },
            showBuildingFieldAddModal(data) {
                this.$eventBus.$emit('showBuildingFieldAddModal', data)
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('buildingFieldChanged', () => {
                this.initList();
            })
        }
    }
</script>

<style scoped>

</style>